export function accountText(lang?: string) {
  const zh = lang === "zh";
  return {
    overview: zh ? "账户概览" : "Account overview",
    overviewBody: zh ? "在这里查看订单、消息、工单、收藏和退货退款。" : "View orders, messages, tickets, wishlist, returns and refunds here.",
    profile: zh ? "个人资料" : "Profile",
    addresses: zh ? "收货地址" : "Addresses",
    addressesBody: zh ? "管理你的收货地址，方便后续结账和物流通知。" : "Manage shipping addresses for checkout and delivery updates.",
    orders: zh ? "我的订单" : "Orders",
    messages: zh ? "站内消息" : "Messages",
    tickets: zh ? "客服工单" : "Tickets",
    wishlist: zh ? "收藏夹" : "Wishlist",
    returns: zh ? "退货退款" : "Returns",
    submit: zh ? "提交" : "Submit",
    order: zh ? "订单" : "Order",
    status: zh ? "状态" : "Status",
    total: zh ? "总计" : "Total",
    logistics: zh ? "物流信息" : "Shipping information",
    company: zh ? "物流公司" : "Shipping company",
    trackingNo: zh ? "物流单号" : "Tracking number",
    trackingUrl: zh ? "查询链接" : "Tracking URL",
    note: zh ? "备注" : "Note",
    reason: zh ? "申请原因" : "Reason",
    ticketHelp: zh ? "请描述你遇到的问题" : "How can we help?",
    loginTitle: zh ? "客户登录" : "Customer login",
    createAccount: zh ? "创建账户" : "Create account",
    name: zh ? "姓名" : "Name",
    email: zh ? "邮箱" : "Email",
    password: zh ? "密码" : "Password",
    login: zh ? "登录" : "Login",
    register: zh ? "注册" : "Register"
  };
}
